import { useEffect, useState } from "react";
import { metaWallet } from "../../../api/Messages";
import { LoadingDiv, SweetAlertShow } from "../../master/Master";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Master from "../Master";
import { formatToDateTime } from "../../master/FormatToDateTime";
import Pagination from "../../components/Pagination";

export default function MetaWaWallet() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [filters, setFilters] = useState({});

  const formatAmount = (amount) => {
    return (Number(amount || 0) / 100).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const getWallet = async () => {
    setLoading(true);

    try {
      let addUrl = "";
      Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value) {
          addUrl += `&${key}=${encodeURIComponent(value)}`;
        }
      });
      const response = await metaWallet(addUrl);

      if (response?.data?.data) {
        setData(response.data.data);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "No data found",
        );
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWallet();
  }, [filters]);

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />

                  <div className="col-12">
                    {/* Wallet Summary */}
                    <div className="row mb-4">
                      <div className="col-md-4 col-sm-6 mb-3">
                        <div className="card border-primary h-100">
                          <div className="card-body text-center">
                            <h6 className="text-muted">Wallet Balance</h6>
                            <h3 className="text-primary">
                              ₹{formatAmount(data?.balance)}
                            </h3>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 col-sm-6 mb-3">
                        <div className="card border-success h-100">
                          <div className="card-body text-center">
                            <h6 className="text-muted">Total Credited</h6>
                            <h3 className="text-success">
                              ₹{formatAmount(data?.total_credited)}
                            </h3>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 col-sm-6 mb-3">
                        <div className="card border-danger h-100">
                          <div className="card-body text-center">
                            <h6 className="text-muted">Total Debited</h6>
                            <h3 className="text-danger">
                              ₹{formatAmount(data?.total_debited)}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Business Details */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h5 className="mb-0">Business Details</h5>
                      </div>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4 col-sm-6 mb-3">
                            <strong>Business Name</strong>
                            <div>
                              {data?.user?.profile?.business_name || "-"}
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6 mb-3">
                            <strong>Display Number</strong>
                            <div>
                              {data?.user?.profile?.display_phone_number || "-"}
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6 mb-3">
                            <strong>Email</strong>
                            <div>{data?.user?.email || "-"}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Transactions */}
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <h5 className="mb-0">Transaction History</h5>

                        <span className="badge bg-primary">
                          {data?.transactions?.total || 0} Transactions
                        </span>
                      </div>

                      <div className="card-body table-responsive">
                        <table className="table table-bordered table-hover align-middle">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Date</th>
                              <th>Type</th>
                              <th>Amount (₹)</th>
                              <th>Balance After (₹)</th>
                              <th>Description</th>
                              <th>Status</th>
                            </tr>
                          </thead>

                          <tbody>
                            {data?.transactions?.total > 0 ? (
                              data.transactions?.data?.map((item, index) => (
                                <tr key={item.id}>
                                  <td>{index + 1}</td>

                                  <td>{formatToDateTime(item.created_at)}</td>

                                  <td>
                                    <span
                                      className={`badge ${
                                        item.type === "credit"
                                          ? "bg-success"
                                          : "bg-danger"
                                      }`}
                                    >
                                      {item.type?.toUpperCase()}
                                    </span>
                                  </td>

                                  <td>₹{formatAmount(item.amount)}</td>

                                  <td>₹{formatAmount(item.balance_after)}</td>

                                  <td>{item.description}</td>

                                  <td>
                                    <span
                                      className={`badge ${
                                        item.status === "completed"
                                          ? "bg-success"
                                          : item.status === "pending"
                                            ? "bg-warning"
                                            : "bg-danger"
                                      }`}
                                    >
                                      {item.status}
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center py-4">
                                  No Transactions Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <Pagination
                          data={data?.transactions}
                          setFilters={setFilters}
                          filters={filters}
                        />
                      </div>
                    </div>
                    {/* End Transactions */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
